import React, { Component } from 'react'
import Modal from 'react-modal'
import PropTypes from 'prop-types'

class Popup extends Component {
    constructor(props) {
        super()
        this.state = {
            showModal: false
        }
    }

    componentWillMount() {
        Modal.setAppElement('body')
    }

    showModal = () => {
        this.setState({ showModal: true })
    }

    hideModal = () => {
        this.setState({ showModal: false })
        this.props.resetModalStatus(false)
    }

    render() {
        return (
            <Modal
                isOpen={this.state.showModal || this.props.isOpen}
                style={this.props.customStyles}
                contentLabel="Example Modal"
            >
                <div>
                    <header className="text-white col-span-3 theme-dark overflow-hidden">
                        <nav className="flex items-center px-6 py-1">
                            <div className="flex-11 mx-autos flex-grow  mx-auto">
                                <div>
                                    <label className="font-semibold" htmlFor="listName">Add Contacts to the list
                                    </label>
                                </div>
                            </div>
                            <button className="font-semibold" data-testid="Popup_buttonId_test" onClick={this.hideModal} className="btn block inline-block ">X</button>
                        </nav>
                    </header>
                </div>
                <div className="">
                    <div className="popupContent">
                        {this.props.children}
                    </div>
                </div>
            </Modal>
        )
    }
}

Popup.propTypes = {
    children: PropTypes.any,
    isOpen: PropTypes.any,
    customStyles: PropTypes.any,
    headerText: PropTypes.any
}

export default Popup
